export enum Role {
  'Admin' = 'ADMIN',
  'Icono' = 'ICONO',
  'Maquettiste' = 'MAQUETTISTE',
  'Nl' = 'NL',
  'NlAdmin' = 'ADMIN_NL',
  'PhotoAdminCuisine' = 'ADMIN_PHOTO_CUISINE',
  'Pigiste' = 'PIGISTE',
  'ReadOnly' = 'READ_ONLY',
  'Redacteur' = 'REDACTEUR',
  'SR' = 'SR',
  'Superadmin' = 'SUPERADMIN',
  'Validateur' = 'VALIDATEUR',
  'Web' = 'WEB',
  'WebAdmin' = 'ADMIN_WEB',
  'IconoVal' = 'ICONOVAL',
}

export function isRole(maybeRole: unknown): maybeRole is Role {
  return Object.entries(Role).some(([, role]) => role === maybeRole);
}

export function assertRole(maybeRole: unknown): Role {
  if (!isRole(maybeRole)) {
    throw new Error(`The role "${maybeRole}" does not exist.`);
  }

  return maybeRole;
}
